var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResponsiveDesign8Rugpdgjj8Fu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "seo-online-marketing-content-ads"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39,56H38V37a3.009,3.009,0,0,0-3-3H7a3.009,3.009,0,0,0-3,3V56H3a1,1,0,0,0-1,1v2a3.009,3.009,0,0,0,3,3H37a3.009,3.009,0,0,0,3-3V57A1,1,0,0,0,39,56ZM6,37a1,1,0,0,1,1-1H35a1,1,0,0,1,1,1V56H6ZM38,59a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V58H38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,34H45a3.009,3.009,0,0,0-3,3V59a3.009,3.009,0,0,0,3,3H59a3.009,3.009,0,0,0,3-3V37A3.009,3.009,0,0,0,59,34Zm1,25a1,1,0,0,1-1,1H45a1,1,0,0,1-1-1V56H60Zm0-5H44V37a1,1,0,0,1,1-1H59a1,1,0,0,1,1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,57H51a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,2H9A1,1,0,0,0,8,3V31a1,1,0,0,0,1,1H55a1,1,0,0,0,1-1V3A1,1,0,0,0,55,2ZM54,30H10V10H54ZM54,8H10V4H54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,5H12a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,5H16a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,5H20a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,19H51a1,1,0,0,0,1-1V12a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1v6A1,1,0,0,0,13,19Zm1-6H50v4H14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,29h6a1,1,0,0,0,1-1V21a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1v7A1,1,0,0,0,13,29Zm1-7h4v5H14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,20H22a1,1,0,0,0-1,1v7a1,1,0,0,0,1,1H51a1,1,0,0,0,1-1V21A1,1,0,0,0,51,20Zm-1,7H23V22H50Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,37H9a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1H33a1,1,0,0,0,1-1V38A1,1,0,0,0,33,37Zm-1,6H10V39H32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,46H9a1,1,0,0,0-1,1v7a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V47A1,1,0,0,0,15,46Zm-1,7H10V48h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,46H18a1,1,0,0,0-1,1v7a1,1,0,0,0,1,1H33a1,1,0,0,0,1-1V47A1,1,0,0,0,33,46Zm-1,7H19V48H32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,46H53a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V47A1,1,0,0,0,57,46Zm-1,5H54V48h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,53h3a1,1,0,0,0,1-1V47a1,1,0,0,0-1-1H47a1,1,0,0,0-1,1v5A1,1,0,0,0,47,53Zm1-5h1v3H48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,45H57a1,1,0,0,0,1-1V38a1,1,0,0,0-1-1H47a1,1,0,0,0-1,1v6A1,1,0,0,0,47,45Zm1-6h8v4H48Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsiveDesign8Rugpdgjj8Fu);
export default __webpack_public_path__ + "static/media/responsive_design_8rugpdgjj8fu.22ef5db78fc4faf55ca79da08c5d7922.svg";
export { ForwardRef as ReactComponent };